import { render, staticRenderFns } from "./UserCredential.vue?vue&type=template&id=04ce5f04&scoped=true&"
import script from "./UserCredential.vue?vue&type=script&lang=js&"
export * from "./UserCredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce5f04",
  null
  
)

export default component.exports